import {KeyboardEvent} from 'react';

const preventSendForm = (keyEvent: KeyboardEvent<HTMLFormElement>) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
        keyEvent.preventDefault();
    }
};

export default preventSendForm;
